import { useAppSelector } from 'reduxTyped'
import { ViewPayloadMissingError } from 'apps/aiAutomation/errors'
import { SidebarViewType } from 'apps/aiAutomation/lib/sidebar'
import { AiAutomationLayoutSelectors } from 'apps/aiAutomation/store/layout'

export const useViewPayload = <View extends SidebarViewType>(view: View) => {
  const result = useAppSelector((state) => AiAutomationLayoutSelectors.getViewPayload(state, view))

  return result
}

export const useEnsuredViewPayload = <View extends SidebarViewType>(view: View) => {
  const result = useAppSelector((state) => AiAutomationLayoutSelectors.getViewPayload(state, view))

  if (!result) {
    throw new ViewPayloadMissingError(view)
  }

  return result
}

export const useViewState = (view: SidebarViewType) => {
  const state = useAppSelector((state) => AiAutomationLayoutSelectors.getViewState(state, view))

  return {
    state,

    isOpen: state === 'open',
    isHidden: state === 'hidden',
    isClosed: state === 'closed',
  }
}
